// extracted by mini-css-extract-plugin
module.exports = {"container":"_2tfEGS","shrinked":"_3CIuQM","icon":"_1H6N0m","title":"_2g3QIu mz-default-dark-font","message":"_3mize7 mz-default-dark-font","button":"_22DLqU"};